// =============================================================================
// 2. AssessMaterialityButton.js
// src/components/RPA/buttons/AssessMaterialityButton.js
// =============================================================================
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function AssessMaterialityButton({ docId, onDone, disabledHint }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [materialityType, setMaterialityType] = useState('auto');
  const [manualAmount, setManualAmount] = useState('');

  const handleClick = () => {
    setShowModal(true);
  };

  const handleSubmit = async () => {
    if (!docId) return;
    
    setLoading(true);
    try {
      const payload = {
        materialityType,
        manualMateriality: materialityType === 'manual' ? parseFloat(manualAmount) : undefined
      };

      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/balance-sheet/assess-materiality`,
        payload,
        { withCredentials: true }
      );
      
      console.log('[ASSESS_MATERIALITY_BTN] Success:', res.data);
      setShowModal(false);
      if (onDone) onDone();
    } catch (err) {
      console.error('[ASSESS_MATERIALITY_BTN] Failed:', err);
      alert(err.response?.data?.message || 'Materiality assessment failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        disabled={loading || !!disabledHint}
        title={disabledHint || 'Assess materiality thresholds'}
        style={{
          background: loading ? '#9ca3af' : (disabledHint ? '#fca5a5' : '#10b981'),
          color: 'white',
          border: 'none',
          padding: '4px 8px',
          borderRadius: 4,
          fontSize: 11,
          cursor: loading || disabledHint ? 'not-allowed' : 'pointer',
          fontWeight: 500
        }}
      >
        {loading ? 'Assessing…' : 'Assess Materiality'}
      </button>

      {showModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 9999
        }}>
          <div style={{
            background: 'white', padding: 24, borderRadius: 12,
            maxWidth: 400, width: '90%', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{ margin: '0 0 16px 0', fontSize: 16 }}>Assess Materiality</h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 8, fontSize: 14 }}>
                <input
                  type="radio"
                  value="auto"
                  checked={materialityType === 'auto'}
                  onChange={(e) => setMaterialityType(e.target.value)}
                />
                {' '}Auto-calculate (5% of total assets or revenue)
              </label>
              <label style={{ display: 'block', fontSize: 14 }}>
                <input
                  type="radio"
                  value="manual"
                  checked={materialityType === 'manual'}
                  onChange={(e) => setMaterialityType(e.target.value)}
                />
                {' '}Manual Override
              </label>
            </div>

            {materialityType === 'manual' && (
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13, fontWeight: 500 }}>
                  Materiality Amount ($)
                </label>
                <input
                  type="number"
                  value={manualAmount}
                  onChange={(e) => setManualAmount(e.target.value)}
                  placeholder="Enter amount"
                  style={{
                    width: '100%', padding: 8, borderRadius: 6,
                    border: '1px solid #d1d5db', fontSize: 14
                  }}
                />
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
              <button
                onClick={() => setShowModal(false)}
                disabled={loading}
                style={{
                  padding: '8px 16px', borderRadius: 6, border: '1px solid #d1d5db',
                  background: 'white', cursor: 'pointer', fontSize: 13
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={loading || (materialityType === 'manual' && !manualAmount)}
                style={{
                  padding: '8px 16px', borderRadius: 6, border: 'none',
                  background: loading ? '#9ca3af' : '#10b981', 
                  color: 'white', cursor: 'pointer',
                  fontWeight: 600, fontSize: 13
                }}
              >
                {loading ? 'Processing…' : 'Assess'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}